import { render, staticRenderFns } from "./BlogPostsTable.vue?vue&type=template&id=2bf3ef34&"
import script from "./BlogPostsTable.vue?vue&type=script&lang=js&"
export * from "./BlogPostsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports